import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

/**
 * @param {object} props
 * @param {JSX.Element} props.element - Das gerenderte Element (z. B. <Statistics />)
 */
const ProtectedRoute = ({ element }) => {
  // Hole isLoggedIn aus dem Redux-State
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const location = useLocation();

  // Wenn isLoggedIn false ist, leite zum Login weiter
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Wenn eingeloggt, rendere das gewünschte Element
  return element;
};

export default ProtectedRoute;
